import { useSyncExternalStore } from "react";
import { APP_ZOOM_CHANGE_EVENT, getAppZoom } from "../helpers/screenScale";

const subscribe = (onChange: () => void) => {
  window.addEventListener(APP_ZOOM_CHANGE_EVENT, onChange);
  return () => window.removeEventListener(APP_ZOOM_CHANGE_EVENT, onChange);
};

/** Re-renders when the automatic screen scale changes. */
export const useAppZoom = (): number =>
  useSyncExternalStore(subscribe, getAppZoom, () => 1);
